export interface ShareDialogConfiguration {
    title?: React.ReactNode;
    url: string;
    expiryDate?: string;
    onClose?: VoidFunction;
    fullscreen?: boolean;
}

export interface SnapshotDialogConfiguration {
    title?: React.ReactNode;
    snapshot: Blob;
    onClose?: VoidFunction;
    fullscreen?: boolean;
}

export function formatDate(timestamp: number, language: string = 'en'): string {
    const date = new Date(timestamp);

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
    };

    return new Intl.DateTimeFormat(language, options).format(date);
}

export function getDialogShareUrl(baseUrl: string, includeInfo?: boolean): string {
    try {
        const shareUrl = new URL(baseUrl);

        if (includeInfo) {
            shareUrl.searchParams.set('i', '1');
        } else {
            shareUrl.searchParams.delete('i');
        }

        return shareUrl.toString();
    } catch {
        return baseUrl;
    }
}
